'use client';

import * as React from 'react';
import { Switch as SwitchPrimitive } from 'radix-ui';

import { cn } from '@/lib/utils';

function Switch({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
    return (
        <SwitchPrimitive.Root
            data-slot="switch"
            className={cn(
                'peer group/switch relative inline-flex h-5.5 w-10 shrink-0 items-center rounded-full border border-transparent transition-all duration-150 outline-none cursor-pointer after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:ring-3 focus-visible:ring-primary-200 data-checked:bg-primary-500 data-unchecked:bg-neutral-300 dark:data-unchecked:bg-border-strong data-disabled:cursor-not-allowed data-disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40',
                className,
            )}
            {...props}
        >
            <SwitchPrimitive.Thumb
                data-slot="switch-thumb"
                className="pointer-events-none block size-4.5 rounded-full bg-white shadow-sm ring-0 transition-transform duration-150 data-checked:translate-x-4.5 data-unchecked:translate-x-0 dark:bg-neutral-200"
            />
        </SwitchPrimitive.Root>
    );
}

export { Switch };
